var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 512 512"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 256,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M512 170v172l-256 32L0 342V170l256-32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M512 0v170H0V0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M512 342v170H0V342Z"
}))));
export default __webpack_public_path__ + "static/media/ru.6228df4a.svg";
export { SvgComponent as ReactComponent };